import { InjectionToken } from 'dependable-react';

import { AppData } from '../state/AppData';
import { I18n } from '../utils/i18n';
import { ApiClient } from './ApiClient';
import { BookService } from './BookService';
import { StorageService } from './StorageService';
import { TranslationsService } from './TranslationsService';

// tslint:disable-next-line: export-name
export const API_CLEINT_TOKEN = new InjectionToken<ApiClient>();
export const APP_DATA_TOKEN = new InjectionToken<AppData>();
export const DEAPIFY_TOKEN = new InjectionToken<(value: any) => any>();
export const I18N_TOKEN = new InjectionToken<I18n>();
export const BOOK_SERVICE_TOKEN = new InjectionToken<BookService>();
export const TRANSLATIONS_SERVICE_TOKEN = new InjectionToken<TranslationsService>();
export const STORAGE_SERVICE_TOKEN = new InjectionToken<StorageService>();
